import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import TransactionHistory from "../../components/TransactionHistory/TransactionHistory";
import LoginHeaderR from "../../components/header/LoginHeaderR";
import Footer from "../../components/footer/FooterW";
import bankicon from "../../images/shapes/bank-pound-icon2 4.png";
import wallet from "../../images/shapes/Group 37274 (1).png";
import { useLocation } from "react-router-dom";
import { API_URL } from "../../constant";
import tcunitswallet from "../../images/shapes/tc-units-wallet 2.png";
import tccashwallet from "../../images/shapes/tc-cash-wallet 1.png";
import walletcashicon from "../../images/shapes/wallet-cash-icon3 2.png";
import tcminiwallet from "../../images/shapes/tcuk_agent_wallet 3.png";
import { MdOutlineDone } from "react-icons/md";
import success from "../../images/shapes/image 1.png";

const WalletR = () => {
  const [transactions, setTransactions] = useState([]);
  const [balance, setBalance] = useState(0);
  const [loading, setLoading] = useState(true);
  const [apiStatus, setApiStatus] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [showPopup, setShowPopup] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [timeLeft, setTimeLeft] = useState(300);
  const [step, setStep] = useState("idle"); // Always start with idle to show request modal
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [hasExistingApplication, setHasExistingApplication] = useState(false);
  const [isMiniAgent, setIsMiniAgent] = useState(false);
  const [applicationStatus, setApplicationStatus] = useState(null);
  const [formLoading, setFormLoading] = useState(false);
  const [miniAgentWalletBalance, setMiniAgentWalletBalance] = useState(0);
  const [showReturnPopup, setShowReturnPopup] = useState(false);
  const [userData, setUserData] = useState({
    id: null,
    email: "",
    name: "",
    business_name: ""
  });

  // Session timeout duration
  const SESSION_TIMEOUT = 5 * 60 * 1000;
  const WARNING_TIME = 60 * 1000;

  // Fetch user profile data
  const fetchUserProfile = async (token) => {
    try {
      const response = await fetch(`${API_URL}/api/retail-business/me`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        if (data.user) {
          setUserData({
            id: data.user.id || data.user.user_id || null,
            email: data.user.email || "",
            name: data.user.name || data.user.full_name || "",
            business_name: data.user.business_name || data.user.company_name || ""
          });
          localStorage.setItem("user", JSON.stringify(data.user));
          return true;
        }
      }
      return false;
    } catch (error) {
      console.error("Error fetching user profile:", error);
      return false;
    }
  };

  // Function to send agent invitation email
  const handleSendAgentInvitation = async () => {
    try {
      setFormLoading(true);
      const token = localStorage.getItem("auth_token") || sessionStorage.getItem("auth_token");
      
      if (!token) {
        alert("Please login again");
        navigate("/work_with_tcuk");
        return;
      }

      // First, ensure we have user data
      if (!userData.id || !userData.email) {
        const fetched = await fetchUserProfile(token);
        if (!fetched) {
          alert("Unable to retrieve user information. Please try again.");
          setFormLoading(false);
          return;
        }
      }

      // Check if we have required data
      if (!userData.id || !userData.email) {
        console.error("Missing required user data:", userData);
        alert("User information is incomplete. Please contact support.");
        setFormLoading(false);
        return;
      }

      // Prepare request data
      const requestData = {
        user_id: userData.id,
        user_email: userData.email,
        user_name: userData.name || "",
        business_name: userData.business_name || "",
      };

      console.log("Sending agent invitation with data:", requestData);

      const response = await fetch(
        `${API_URL}/api/retail-business/send-agent-invitation`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(requestData),
        }
      );

      const result = await response.json();

      if (response.ok && result.success) {
        console.log("✅ Invitation email sent successfully:", result);
        setShowSuccessModal(true);
        setStep("progress");
      } else {
        console.error("❌ Failed to send invitation email:", result);
        alert(result.message || "Failed to send invitation. Please try again.");
      }
    } catch (error) {
      console.error("❌ Error sending invitation email:", error);
      alert("Network error. Please check your connection and try again.");
    } finally {
      setFormLoading(false);
    }
  };

  const handleRequest = () => {
    handleSendAgentInvitation();
  };

  const handleSuccessModalClose = () => {
    setShowSuccessModal(false);
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const tempTokenKey = urlParams.get("temp_token_key");

    if (tempTokenKey) {
      const tempToken = localStorage.getItem(tempTokenKey);
      if (tempToken) {
        localStorage.setItem("auth_token", tempToken);
        localStorage.removeItem(tempTokenKey);
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname
        );
      }
    }
  }, []);

  const handleClick = () => {
    if (balance < 20000) {
      setShowMessage(true);
      setTimeout(() => {
        setShowMessage(false);
      }, 5000);
    } else {
      alert("Conversion process started!");
    }
  };

  const logout = () => {
    console.log("🔄 Auto-logout due to inactivity");
    localStorage.removeItem("auth_token");
    localStorage.removeItem("is_first_login");
    localStorage.removeItem("last_activity_time");
    localStorage.removeItem("user");
    sessionStorage.removeItem("just_logged_in");
    navigate("/work_with_tcuk");
  };

  const resetTimer = () => {
    const newTime = Date.now().toString();
    localStorage.setItem("last_activity_time", newTime);
    setTimeLeft(300);
    console.log("🔄 Activity detected, session timer reset");
  };

  const setupActivityListeners = () => {
    const events = [
      "mousedown",
      "mousemove",
      "keypress",
      "keydown",
      "scroll",
      "touchstart",
      "click",
      "touchmove",
      "wheel",
    ];

    events.forEach((event) => {
      document.addEventListener(event, resetTimer, { passive: true });
    });

    document.addEventListener("visibilitychange", () => {
      if (!document.hidden) {
        resetTimer();
      }
    });

    return () => {
      events.forEach((event) => {
        document.removeEventListener(event, resetTimer);
      });
      document.removeEventListener("visibilitychange", resetTimer);
    };
  };

  const checkSession = () => {
    const token = localStorage.getItem("auth_token");
    const lastActivity = localStorage.getItem("last_activity_time");

    if (!token) {
      console.log("❌ No token found");
      navigate("/work_with_tcuk");
      return false;
    }

    if (lastActivity) {
      const currentTime = Date.now();
      const elapsedTime = currentTime - parseInt(lastActivity);
      const remainingTime = Math.max(0, SESSION_TIMEOUT - elapsedTime);

      setTimeLeft(Math.floor(remainingTime / 1000));

      if (elapsedTime > SESSION_TIMEOUT) {
        console.log("⏰ Session expired, logging out");
        logout();
        return false;
      }
    } else {
      resetTimer();
    }

    return true;
  };

  const checkApiStatus = async () => {
    try {
      const response = await fetch(`${API_URL}/api/laravel-test`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        timeout: 10000,
      });

      if (response.ok) {
        setApiStatus(true);
        return true;
      } else {
        setApiStatus(false);
        return false;
      }
    } catch (error) {
      console.error("🚨 API status check failed:", error);
      setApiStatus(false);
      return false;
    }
  };

  const handleTransactionNavigation = (e) => {
    e.preventDefault();
    resetTimer();
    navigate("/retail-business/transaction");
  };

  const handleMiniTransactionNavigation = (e) => {
    e.preventDefault();
    resetTimer();
    navigate("/mini-agent-transaction-history");
  };

  const processOAuthToken = () => {
    const queryParams = new URLSearchParams(location.search);
    const tokenFromUrl = queryParams.get("token");
    const firstLogin = queryParams.get("firstLogin") === "true";

    if (tokenFromUrl) {
      console.log("🔑 OAuth token received via URL");
      localStorage.setItem("auth_token", tokenFromUrl);
      sessionStorage.setItem("just_logged_in", "true");
    }

    if (firstLogin) {
      console.log("🎉 First login detected from URL");
      localStorage.setItem("is_first_login", "true");
    }

    resetTimer();

    if (tokenFromUrl || firstLogin) {
      window.history.replaceState({}, document.title, "/retail-business/wallet");
    }

    return !!(tokenFromUrl || firstLogin);
  };

  const fetchWalletData = async (token) => {
    try {
      const response = await fetch(`${API_URL}/api/retail-business/wallet`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const contentType = response.headers.get("content-type");
      const isJson = contentType && contentType.includes("application/json");

      if (!response.ok) {
        const errorData = isJson
          ? await response.json()
          : await response.text();
        const message = isJson
          ? errorData.message || "Failed to fetch wallet data"
          : `Error ${response.status}: ${response.statusText}`;
        throw new Error(message);
      }

      const data = await response.json();
      setTransactions(data.transactions || []);
      setBalance(data.points || 0);
      setMiniAgentWalletBalance(data.agent_wallet_points || 0);

      // Try to get user data from wallet response
      if (data.user) {
        setUserData({
          id: data.user.id || data.user.user_id || null,
          email: data.user.email || "",
          name: data.user.name || data.user.full_name || "",
          business_name: data.user.business_name || data.user.company_name || ""
        });
        localStorage.setItem("user", JSON.stringify(data.user));
      }

      const isFirstLogin = localStorage.getItem("is_first_login") === "true";
      if (isFirstLogin) {
        setShowPopup(true);
        localStorage.setItem("is_first_login", "false");
      }

      return true;
    } catch (error) {
      console.error("🚨 Wallet fetch error:", error.message);
      if (
        error.message.includes("401") ||
        error.message.includes("403") ||
        error.message.includes("500")
      ) {
        logout();
        return false;
      }
      throw error;
    }
  };

  useEffect(() => {
    const initWallet = async () => {
      try {
        const hasOAuthToken = processOAuthToken();
        const isSessionValid = checkSession();
        
        if (!isSessionValid) {
          return;
        }

        const isApiOnline = await checkApiStatus();

        if (!isApiOnline) {
          console.error("API is not available, redirecting to login");
          logout();
          return;
        }

        const token = localStorage.getItem("auth_token");
        if (!token) {
          navigate("/work_with_tcuk");
          return;
        }

        await fetchWalletData(token);
        
        // If user data not loaded from wallet, try to fetch it separately
        if (!userData.id || !userData.email) {
          await fetchUserProfile(token);
        }
      } catch (error) {
        console.error("🚨 Wallet initialization error:", error);
      } finally {
        setLoading(false);
      }
    };

    initWallet();

    const cleanupActivityListeners = setupActivityListeners();

    const sessionCheckInterval = setInterval(() => {
      checkSession();
    }, 10000);

    const countdownInterval = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          checkSession();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      cleanupActivityListeners();
      clearInterval(sessionCheckInterval);
      clearInterval(countdownInterval);
    };
  }, [navigate, location]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
  };

  if (apiStatus === false) {
    return (
      <div className="wallet-loading">
        <LoginHeaderR />
        <div className="wallet-container" style={{ maxWidth: "500px" }}>
          <div className="wallet-content">
            <div className="wallet-left">
              <div className="wallet-left-text">
                <h2 className="highlight">Service Unavailable</h2>
                <p>Please try again later.</p>
                <button
                  onClick={() => navigate("/work_with_tcuk")}
                  className="active-button"
                >
                  Return to Login
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (loading || apiStatus === null) {
    return (
      <div className="wallet-loading">
        <LoginHeaderR />
        <div className="wallet-container" style={{ maxWidth: "500px" }}>
          <div className="wallet-content">
            <div className="wallet-left">
              <div className="wallet-left-text">
                <h2 className="highlight">TopCoin Wallet</h2>
                <p className="balance-label">Available Balance</p>
                <h1 className="balance-value">Loading...</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="pt-5" style={{ backgroundColor: "#001964" }}>
      <LoginHeaderR />

      <div className="wallet-container">
        {/* REMOVED: TCUK Business Ads Agent Wallet section - completely removed */}

        <div className="wallet-content">
          <div className="wallet-left">
            <div className="wallet-left-text">
              <h2 className="highlight">TopCoin Wallet</h2>
              <img
                className="wallet-icon1"
                src={tcunitswallet}
                alt="wallet icon"
              />
              <p className="balance-label">Available Balance</p>
              <h1 className="balance-value">{balance} TopCoin</h1>
              <div className="mb-8 pt-4 text-center">
                <button
                  onClick={handleTransactionNavigation}
                  style={{
                    color: "#9F4AFF",
                    fontWeight: "500",
                    textDecoration: "none",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    fontSize: "inherit",
                  }}
                >
                  Transaction History &gt;&gt;
                </button>
              </div>
            </div>

            <div className="wallet-left-text wallet-left-text2">
              <h2 className="highlight">Current TopCoin Value</h2>
              <img
                className="wallet-icon1"
                src={walletcashicon}
                alt="wallet icon"
              />
              <h1 className="coin-value">
                Current value = £{(balance * 0.005).toFixed(2)}
              </h1>
            </div>
          </div>

          <div className="wallet-left wallet-left1">
            <div className="wallet-left-text wallet-left-text1">
              <h2 className="highlight">TopCoin Cash Wallet</h2>
              <img
                className="wallet-icon1"
                src={tccashwallet}
                alt="wallet icon"
              />
              <h2 className="highlight cash-wallet1">N/A</h2>
            </div>

            <div className="bank-request">
              <p className="convert-text">Convert your TopCoin into cash</p>
              <img className="bank-icon" src={bankicon} alt="bankicon" />
              <h1 className="coin-value " style={{ color: "#888" }}>
                Request to bank
              </h1>
              <button
                className={
                  balance >= 20000 ? "active-button" : "disabled-button2"
                }
                onClick={handleClick}
              >
                Request
              </button>
              {showMessage && (
                <h3 className="message">
                  This feature will be available once you reach 20,000 TopCoin.
                </h3>
              )}
            </div>
          </div>
        </div>

        {/* ALWAYS SHOW: Business Agent Request Modal */}
        <div className="mini-agent">
          {step === "idle" && (
            <>
              <h2 className="highlight-request">
                Become TCUK Business Ads Agent (Business Ads Agent)
              </h2>
              <p
                style={{
                  textAlign: "start",
                  color: "#999999",
                  padding: "0px 0px 0px 190px",
                }}
              >
                <b>
                  <MdOutlineDone style={{ color: "#000" }} />
                </b>{" "}
                Become an Agent to start earn more Topcoin
              </p>
              <button
                onClick={handleRequest}
                disabled={formLoading}
                style={{
                  color: formLoading ? "#888" : "#9F4AFF",
                  fontWeight: "500",
                  textDecoration: "none",
                  background: "none",
                  border: "none",
                  cursor: formLoading ? "not-allowed" : "pointer",
                  fontSize: "inherit",
                }}
              >
                {formLoading ? "Sending..." : "Request >>"}
              </button>
            </>
          )}

          {step === "progress" && (
            <>
              <h2 className="highlight-request">
                Become TCUK Business Ads Agent (Business Ads Agent)
              </h2>
              <p
                style={{
                  textAlign: "start",
                  color: "#999999",
                  padding: "0px 0px 0px 190px",
                }}
              >
                <b>
                  <MdOutlineDone style={{ color: "#000" }} />
                </b>{" "}
                Invitation Email Sent
              </p>
              <p
                style={{
                  textAlign: "start",
                  color: "#999999",
                  padding: "0px 0px 0px 190px",
                }}
              >
                <b>
                  <MdOutlineDone style={{ color: "#000" }} />
                </b>{" "}
                Please check your email and apply with alternative email
              </p>
              <button
                disabled
                style={{
                  color: "#44475C",
                  fontWeight: "500",
                  textDecoration: "none",
                  background: "none",
                  border: "none",
                  cursor: "not-allowed",
                  fontSize: "inherit",
                }}
              >
                Request Sent ✓
              </button>
            </>
          )}

          {step === "rejected" && (
            <>
              <h2 className="highlight-request" style={{ color: "#dc3545" }}>
                Application Status: Rejected
              </h2>
              <p
                style={{
                  textAlign: "center",
                  color: "#666",
                  padding: "10px 0",
                }}
              >
                Your mini agent application has been rejected. Please contact
                support for more information.
              </p>
              <button
                onClick={handleRequest}
                style={{
                  color: "#9F4AFF",
                  fontWeight: "500",
                  textDecoration: "none",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  fontSize: "inherit",
                }}
              >
                Try Again &gt;&gt;
              </button>
            </>
          )}
        </div>

        {showSuccessModal && (
          <div className="modal-overlay">
            <div className="success-modal-box">
              <h3>
                Thank you for your interest in becoming a TCUK Business Ads
                Agent.
              </h3>
              <img className="success-mail" src={success} alt="success icon" />
              <p>We have sent an invitation email to your registered email address.</p>
              <button className="ok-btn" onClick={handleSuccessModalClose}>
                OK
              </button>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default WalletR;